export default __webpack_public_path__ + "static/media/background.fa257a4a.jpg";